/*
 * Bravo · Fecha de entrega estimada en la ficha de producto.
 *
 * Mismo cálculo que la entrega estimada del carrito (snippets/cart-drawer.liquid),
 * pero con los datos sacados de los ajustes del theme (ver snippets/bravo-delivery-estimate.liquid):
 *   - Si hoy es laborable y aún no es la hora de corte, el pedido sale hoy; si no,
 *     el siguiente día laborable.
 *   - Entrega entre "salida + días mínimos" y "salida + días máximos", contando
 *     solo laborables (lunes a viernes, sin festivos).
 *   - La hora se toma en la zona horaria del almacén, no en la del cliente.
 *
 * Los nombres de días y meses los pone el navegador en el idioma de la tienda.
 * Se oculta cuando la variante elegida no tiene stock.
 */
(function () {
  'use strict';

  if (customElements.get('bravo-delivery-estimate')) return;

  // Festivos nacionales fijos de España (los mismos que usa el carrito) + Viernes Santo
  var NATIONAL_FIXED = [[1, 1], [1, 6], [5, 1], [8, 15], [10, 12], [11, 1], [12, 6], [12, 8], [12, 25]];

  // Las fechas se manejan como días UTC a mediodía, para que los cambios de hora no muevan el día
  function day(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d, 12));
  }

  function key(date) {
    return date.toISOString().slice(0, 10);
  }

  function addDays(date, n) {
    return new Date(date.getTime() + n * 86400000);
  }

  // Domingo de Pascua (algoritmo de Gauss, el mismo que el carrito)
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var dayOfMonth = ((h + l - 7 * m + 114) % 31) + 1;
    return day(y, month, dayOfMonth);
  }

  function buildHolidays(years, national, extraRaw) {
    var set = {};
    if (national) {
      years.forEach(function (y) {
        NATIONAL_FIXED.forEach(function (md) { set[key(day(y, md[0], md[1]))] = true; });
        set[key(addDays(easter(y), -2))] = true;
      });
    }
    (extraRaw || '').split(/[\s,;]+/).forEach(function (s) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) set[s] = true;
    });
    return set;
  }

  // Fecha y hora actuales en la zona horaria del almacén
  function nowIn(timeZone) {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric'
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var local = new Date();
      parts = { year: local.getFullYear(), month: local.getMonth() + 1, day: local.getDate(), hour: local.getHours() };
    }
    return {
      date: day(Number(parts.year), Number(parts.month), Number(parts.day)),
      hour: Number(parts.hour)
    };
  }

  function isBizDay(date, holidays) {
    var dow = date.getUTCDay();
    return dow !== 0 && dow !== 6 && !holidays[key(date)];
  }

  function addBizDays(date, n, holidays) {
    var d = date;
    var count = 0;
    while (count < n) {
      d = addDays(d, 1);
      if (isBizDay(d, holidays)) count++;
    }
    return d;
  }

  /*
   * Mismo formato que el carrito: "Jue. 8 oct.". Los nombres de día y mes los da el
   * navegador en el idioma de la tienda; aquí solo se les da la forma (mayúscula
   * inicial en el día y punto de abreviatura en día y mes).
   */
  function formatDate(date, locale) {
    var opts = { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' };
    var parts = {};
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(locale || undefined, opts);
    } catch (e) {
      fmt = new Intl.DateTimeFormat(undefined, opts);
    }
    fmt.formatToParts(date).forEach(function (p) { parts[p.type] = p.value; });

    var abbr = function (s) { return s.replace(/\.$/, '') + '.'; };
    var weekday = parts.weekday.charAt(0).toUpperCase() + parts.weekday.slice(1);
    var month = parts.month.replace(/\.$/, '');
    // En español el navegador escribe "sept"; el carrito usa "sep", como el resto de meses (3 letras)
    if (/^es/i.test(locale || '')) month = month.slice(0, 3);
    return abbr(weekday) + ' ' + parts.day + ' ' + abbr(month);
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  customElements.define('bravo-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-bravo-delivery-text]');
      try {
        this.variants = JSON.parse(this.querySelector('[data-bravo-delivery-variants]').textContent);
      } catch (e) {
        this.variants = {};
      }

      this.render();

      // El theme dispara "change" en el input name="id" del formulario al cambiar de variante
      this.productInfo = this.closest('product-info') || document;
      this.onVariantChange = this.onVariantChange.bind(this);
      this.productInfo.addEventListener('change', this.onVariantChange);
    }

    disconnectedCallback() {
      if (this.productInfo) this.productInfo.removeEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
      var input = event.target;
      if (!input || input.name !== 'id') return;
      var available = this.variants[input.value];
      // Variante desconocida (p. ej. otro producto en la misma página): no se toca
      if (typeof available !== 'boolean') return;
      this.hidden = !available;
    }

    render() {
      if (!this.textEl) return;

      var cutoff = parseInt(this.dataset.cutoffHour, 10);
      var minDays = parseInt(this.dataset.minDays, 10);
      var maxDays = parseInt(this.dataset.maxDays, 10);
      if (isNaN(cutoff)) cutoff = 14;
      if (isNaN(minDays)) minDays = 1;
      if (isNaN(maxDays) || maxDays < minDays) maxDays = minDays;

      var now = nowIn(this.dataset.timezone || 'Europe/Madrid');
      var year = now.date.getUTCFullYear();
      var holidays = buildHolidays([year, year + 1], this.dataset.nationalHolidays !== 'false', this.dataset.extraHolidays);

      var dispatch = now.date;
      if (!isBizDay(dispatch, holidays) || now.hour >= cutoff) {
        do { dispatch = addDays(dispatch, 1); } while (!isBizDay(dispatch, holidays));
      }

      var from = addBizDays(dispatch, minDays, holidays);
      var to = addBizDays(dispatch, maxDays, holidays);

      var text = escapeHtml(this.dataset.text || '[desde] – [hasta]');
      var fromHtml = '<strong>' + escapeHtml(formatDate(from, this.dataset.locale)) + '</strong>';
      var toHtml = '<strong>' + escapeHtml(formatDate(to, this.dataset.locale)) + '</strong>';

      if (key(from) === key(to)) {
        // Mismo día: se quita el "– [hasta]" para no repetir la fecha
        text = text.replace(/\s*[–-]\s*\[hasta\]/, '');
      }

      this.textEl.innerHTML = text.replace('[desde]', fromHtml).replace('[hasta]', toHtml);
    }
  });
})();
